import React from "react";

export const HOMEPAGE_HERO_SLIDES = [
  {
    heading: "Babies sleep better",
    className: "baby_slide",
    image: "hero-baby@2x.jpg",
    imgixProps: { fit: "unset", q: "70" },
  },
  {
    heading: "Toddlers sleep better",
    className: "toddler_slide",
    image: "hero-toddler@2x.jpg",
    imgixProps: { fit: "unset", q: "70" },
  },
  {
    heading: "Kids sleep better",
    className: "kid_slide",
    image: "hero-kid@2x.jpg",
    imgixProps: { fit: "unset", q: "70" },
  },
  {
    heading: "Dads sleep better",
    className: "dad_slide",
    image: "hero-dad@2x.jpg",
    imgixProps: { fit: "unset" },
  },
  {
    heading: "Moms sleep better",
    className: "mom_slide",
    image: "hero-mom@2x.jpg",
    imgixProps: { fit: "unset" },
  },
];

export const SLEEP_HOMEPAGE_RESTORE_FEATURES = [
  {
    label: "Personal sleep routine",
    icon: "restore-icon-personal-sleep-routine.svg",
    alt: "Personal sleep routine",
  },
  {
    label: "Reading light",
    icon: "restore-icon-reading-light.svg",
    alt: "Reading light",
  },
  {
    label: "Sleep sounds",
    icon: "restore-icon-sleep-sounds.svg",
    alt: "Sleep sounds",
  },
  {
    label: "Sunrise alarm",
    icon: "restore-icon-sunrise-alarm.svg",
    alt: "Sunrise alarm",
  },
];

export const SLEEP_HOMEPAGE_STATISTICS = [
  [<>72&#37; of adults</>, "want better quality sleep"],
  ["They spend an average of", "90 minutes", "lying awake at night"],
  ["And wake up on", "the wrong side of the bed", <>300&#215; a year</>],
  [
    "We can help. At Hatch,",
    "we're making a good night",
    <>of sleep easier&#8212;</>,
    "for everyone",
  ],
];

export const HOMEPAGE_SLEEP_CAROUSELS = [
  {
    posterImage: "Restore-case-flip-1.jpg",
    appImage: "restore-routine-screen.png",
    headline: (
      <>
        Fall asleep,
        <br /> stay asleep.
      </>
    ),
    alt: "Fall asleep, stay asleep with Hatch Restore",
    description: (
      <>
        Customize your routine with a reading light, wind down content, sleep
        sounds &amp; more.
      </>
    ),
  },
  {
    posterImage: "Restore-case-flip-2.jpg",
    appImage: "restore-wakeup-screen.png",
    headline: (
      <>
        Wake up
        <br /> refreshed.
      </>
    ),
    alt: "Wake up refreshed with Hatch Restore",
    description:
      "Wake up naturally as Restore gradually brightens before your alarm to simulate a natural sunrise.",
  },
  {
    posterImage: "Restore-case-flip-3.jpg",
    appImage: "restore-color-screen.png",
    headline: (
      <>
        Set a mood,
        <br /> any time.
      </>
    ),
    alt: "Make it all about you with Hatch Restore",
    description:
      "Enjoy a library of soothing sounds & light hues to help you focus, relax, or meditate.",
  },
];

export const HOMEPAGE_FAMILY_CAROUSEL_SLIDES = [
  {
    title: "For Adults",
    image: "Hatch_Restore_Hero_Render_blue.jpg",
    isNew: true,
    linkProps: { to: "/restore" },
    alt: "For Adults",
  },
  {
    title: <>For Babies &amp; Kids</>,
    image: "Hatch_Rest_Family_Teal.jpg",
    linkProps: { to: "/rest" },
    alt: "For Babies and Kids",
  },
];

export const HOMEPAGE_REVIEWS = [
  {
    reviewer: "Raquel P.",
    review:
      "Before we purchased the Rest, our 2.5 year old daughter would wake up anytime between 6 and 7 am and would call for us loudly to come and get her. Now she stays in bed quietly talking or singing to herself until the green light turns on and we are able to have time to ourselves in the morning. It's the best thing! Highly recommended!",
    title: "It’s a miracle!",
  },
  {
    reviewer: "Linda S.",
    review: (
      <>
        Love this sound machine/night light! Useful from birth&#43;, totally
        worth the money. My son sleeps so much better at night because of it!
      </>
    ),
    title: "The best",
  },
  {
    reviewer: "Patrick V.",
    review:
      "The amazing Rest nightlight and sound machine was a pure lifesaver for us, especially as our little peanut recently hit the 4-month sleep regression phase and was fighting naps and starting to wake up at odd hours. The Hatch Baby Rest enabled us to program healthy and longer sleep patterns for our baby and afforded us more sleep too.",
    title: "Puts the joy back into parenting",
  },
];

export const HOMEPAGE_STATISTICS = SLEEP_HOMEPAGE_STATISTICS.filter(
  (stat, idx) => idx !== 1
);
